import React from 'react';

/**
 * SidebarSkeleton provides a placeholder UI for the sidebar during loading.
 */
const SidebarSkeleton = () => {
  return (
    <div className="sidebar-skeleton bg-gray-200 animate-pulse h-full w-[282px] p-4 flex flex-col">
      {/* Skeleton for Logo area */}
      <div className="sidebar-skeleton__logo h-10 bg-gray-300 rounded mb-8"></div>

      {/* Skeleton for Nav items */}
      <div className="sidebar-skeleton__nav flex-grow space-y-4">
        <div className="sidebar-skeleton__nav-item h-8 bg-gray-300 rounded"></div>
        <div className="sidebar-skeleton__nav-item h-8 bg-gray-300 rounded w-5/6"></div>
        <div className="sidebar-skeleton__nav-item h-8 bg-gray-300 rounded"></div>
        <div className="sidebar-skeleton__nav-item h-8 bg-gray-300 rounded w-4/6"></div>
        <div className="sidebar-skeleton__nav-item h-8 bg-gray-300 rounded"></div>
      </div>

      {/* Skeleton for Bottom items (e.g., Settings, Logout) */}
      <div className="sidebar-skeleton__bottom mt-auto space-y-4">
        <div className="sidebar-skeleton__bottom-item h-8 bg-gray-300 rounded"></div>
        <div className="sidebar-skeleton__bottom-item h-8 bg-gray-300 rounded w-3/4"></div>
      </div>
    </div>
  );
};

export default SidebarSkeleton; 